export const actionTypes = {
    AUDIT_LOCATIONS_CLEAR: "AUDIT_LOCATIONS_CLEAR",
    AUDIT_LOCATIONS_SET: "AUDIT_LOCATIONS_SET"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_LOCATIONS_CLEAR
    }),
    set: (auditLocations: Array<any>) => ({
        type: actionTypes.AUDIT_LOCATIONS_SET,
        payload: { auditLocations }
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
